import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})

export class SubjectService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewSubject() {
    return this.http.get(this.baseurl +'/api/Subjects/GetSubjects')
  }

  addSubject(subjectForm) {
    console.log(subjectForm);
    return this.http.post(this.baseurl+'/api/Subjects', subjectForm)
  }

  editSubject(id, subjectForm) {
    console.log(subjectForm);
    return this.http.put(this.baseurl +`/api/Subjects/${id}`, subjectForm, )
  }

  deleteSubject(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Subjects/${id}`)
  }

}
